import React from 'react'
// import contactImg from "../../assets/contact.webp"
import contactImg from "../../assets/IMG_2917.JPG"

const Conatct = () => {
    return (
        <div className='contact pt-[50px] pb-[100px]'>
            <div className="container mx-auto">
                <div className="grid lg:grid-cols-2 grid-cols-1 gap-[100px]">
                    <div className="left">
                        <h1 className='text-[60px] font-bold'>
                            Contact Us
                        </h1>
                        <p className='text-lg'>Feel free to contact us and we’ll get back to you as soon as we can</p>

                        <form action="" className='mt-8'>
                            <div className="grid gap-4 lg:grid-cols-2 grid-cols-1">
                                <div className="item">
                                    <input type="text" placeholder='Your Name' className='w-full px-4 py-3 border border-black rounded-xl placeholder:text-gray-500' />
                                </div>
                                <div className="item">
                                    <input type="email" placeholder='Email Address *' required className='w-full px-4 py-3 border border-black rounded-xl placeholder:text-gray-500' />
                                </div>
                                <div className="item">
                                    <input type="number" placeholder='Mobile Number' className='w-full px-4 py-3 border border-black rounded-xl placeholder:text-gray-500' />
                                </div>
                                <div className="item">
                                    <select name="" id="" className='w-full px-4 py-3 border border-black rounded-xl placeholder:text-gray-500'>
                                        <option value="">Inquiry Type</option>
                                        <option value="Artist">Artist</option>
                                        <option value="Team">Team</option>
                                        <option value="Company">Company</option>
                                        <option value="Business">Business</option>
                                        <option value="Individual">Individual</option>
                                    </select>
                                </div>
                                <div className="item lg:col-span-2">
                                    <textarea name="" id="" cols="30" rows="5" placeholder='Message' className='w-full px-4 py-3 border border-black rounded-xl placeholder:text-gray-500'></textarea>

                                    <div className="mt-5 text-center">
                                        <button className='text-white bg-black border-0 uppercase px-4 py-3 rounded-[6px] font-semibold'>
                                            Submit enqury
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="right flex justify-end">
                        <img src={contactImg} className='w-full lg:w-11/12' alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Conatct
